module.exports = {
      id: "gztrending-usage",
      viewBox: "0 0 18.806 24.145",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#gztrending",
      toString: function () {
        return this.url;
      }
    }